export default [
  {
    path: "/penangkar-benih/",
    component: () => import("@/pages/penangkar-benih/penangkar-benih-list.vue"),
    meta: { title: "Daftar Penangkar Benih" },
  },
  {
    path: "/penangkar-benih/create",
    component: () => import("@/pages/penangkar-benih/penangkar-benih-form.vue"),
    meta: { title: "Tambah Penangkar Benih" },
  },
  {
    path: "/penangkar-benih/detail/:id",
    component: () =>
      import("@/pages/penangkar-benih/penangkar-benih-detail.vue"),
    meta: { title: "Detail Penangkar Benih" },
  },
  {
    path: "/penangkar-benih/update/:id",
    component: () =>
      import("@/pages/penangkar-benih/penangkar-benih-update.vue"),
    meta: { title: "Edit Penangkar Benih" },
  },
  {
    path: "/penangkar-benih/import",
    component: () =>
      import("@/pages/penangkar-benih/penangkar-benih-import.vue"),
    meta: { title: "Import Penangkar Benih" },
  },
];
